// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__jdbhg","spinner_img":"styles_spinner_img__p-SH0","App-logo-spin":"styles_App-logo-spin__jgyWN"};